import React from 'react';
import SimpleModal from '../../../components/Modals/SimpleModal';
import {Grid, Icon, Typography
} from '@mui/material'
import { green } from '@mui/material/colors';
import ContainedButton from '../../../components/actions/ContainedButton';
import {makeStyles} from '@mui/styles'

/**
 * @module Layouts/Registration/modals/SuccessModal
 * @description The SuccessModal component displays a modal with a success message and a button to close it.
 */

/**
 * 
 * @typedef SuccessModal
 * @property {MUIStyles} classes - The styles for the component 
 * @property {Boolean} open - Variables that handles if this component is shown or not
 * @property {Function} onClose - This function closes this Component Modal
 * @return The SuccessModal component is being returned.
 
*/
const SuccessModal = (props) => {

    const classes = useStyles()
    const {open, onClose, onResetForm} = props

    const onInnerClose = () => {
        onResetForm()
        onClose()
    }

    return ( 
        <SimpleModal open={open} onClose={onInnerClose}>
            <div className={classes.root}>
                <Grid container justifyContent='center' spacing={3}>
                    <Grid item>
                        <div className={classes.icon_container}>
                            <Icon className={classes.icon}>done</Icon>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography align='center'>
                            The cardholder has been created successfully
                        </Typography>
                    </Grid>
                    <Grid item>
                        <ContainedButton color='secondary' onClick={onInnerClose}>Finish</ContainedButton>
                    </Grid>
                </Grid>
            </div>
        </SimpleModal>
     );
}

const useStyles = makeStyles(theme => ({
    root:{
        paddingTop:30
    },
    icon_container:{
        width:80,
        height:80,
        borderRadius:'50%',
        border:`1px solid ${green[700]}`,
        position:'relative'
    },
    icon:{
        position:'absolute',
        top:'50%', left:'50%',
        transform:'translate(-50%, -50%)',
        color:green[700],
        fontSize:48
    }
}))
 
export default SuccessModal;